module.exports = __webpack_public_path__ + "img/sub_page_communication7.6a4e8527.png";